export type TranslationProduct = "Root" | "toolkit";

export type TranslationTextRef = {
  readonly key: string;
  readonly product?: TranslationProduct;
};

export const texts = {
  go_to: { key: "go_to", product: "Root" },
  english: { key: "english", product: "Root" },
  swedish: { key: "swedish", product: "Root" },
  header_subtitle: { key: "header_subtitle" },
  retry: { key: "retry" },
  no_tools_available: { key: "no_tools_available" },
  no_tools_found: { key: "no_tools_found" },
  available_tools: { key: "available_tools", product: "Root" },
  explore_tools: { key: "explore_tools" },
  take_a_look: { key: "take_a_look" },
  log_in: { key: "log_in" },
  residential: { key: "residential" },
  commercial: { key: "commercial" },
  tools_heading: { key: "tools_heading" },
  hero_heading: { key: "hero_heading" },
  residential_cta: { key: "residential_cta" },
  commercial_cta: { key: "commercial_cta" },
} as const;
